import { MARQUEE } from "../../content/site";

const Row = () => (
  <div className="flex shrink-0 items-center">
    {MARQUEE.map((w) => (
      <span key={w} className="flex items-center">
        <span className="px-6 font-serif text-3xl italic text-ink sm:px-10 sm:text-5xl">{w}</span>
        <svg viewBox="0 0 20 20" className="h-4 w-4 text-gold sm:h-5 sm:w-5" aria-hidden="true">
          <path d="M10 0l2.4 7.6L20 10l-7.6 2.4L10 20l-2.4-7.6L0 10l7.6-2.4z" fill="currentColor" />
        </svg>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div className="relative overflow-hidden border-y border-gold/20 bg-cream-deep py-6 sm:py-8" data-testid="editorial-marquee" aria-hidden="true">
    <div className="marquee-track flex w-max">
      <Row />
      <Row />
    </div>
  </div>
);
